import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi }    from '@angular/common/http';
import { AppComponent } from './app.component';
import { LoginComponent } from './component/login/login.component';
import { HomeComponent } from './component/home/home.component';
import { HeaderComponent } from './component/header/header.component';
import { CatalogComponent } from './component/catalog/catalog.component';
import { ProductsComponent } from './component/products/products.component';
import { SystemsComponent } from './component/systems/systems.component';
import { PlansComponent } from './component/plans/plans.component';
import { ActivitiesComponent } from './component/activities/activities.component';
import { SettingsComponent } from './component/settings/settings.component';
import { FromNowPipe } from './pipe/from-now.pipe';
import { UnregisteredAgentPipe } from './pipe/unregistered-agent.pipe';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { MainComponent } from './component/main/main.component';
import { BreadcrumbsComponent } from './component/controls/breadcrumbs/breadcrumbs.component';
import { CatalogFilterPipe } from './pipe/catalog-filter.pipe';
import { CatalogDetailsComponent } from './component/catalog-details/catalog-details.component';
import { PlansOverviewComponent } from './component/plans-overview/plans-overview.component';
import { PlansDetailsComponent } from './component/plans-details/plans-details.component';
import { CatalogOverviewComponent } from './component/catalog-overview/catalog-overview.component';
import { OrderByPipe } from './pipe/order-by.pipe';
import { FilterByPipe } from './pipe/filter-by.pipe';
import { SystemsOverviewComponent } from './component/systems-overview/systems-overview.component';
import { SystemsDetailsComponent } from './component/systems-details/systems-details.component';
import { AboutBoxComponent } from './component/about-box/about-box.component';
import { UserFormComponent } from './component/user-form/user-form.component';
import { ModalViewComponent } from './component/controls/modal/modal-view/modal-view.component';
import { ModalViewDirective } from './component/controls/modal/modal-view.directive';
import { HeaderProfileComponent } from './component/header-profile/header-profile.component';
import { ModalTitleComponent } from './component/controls/modal/modal-title/modal-title.component';
import { ModalBodyComponent } from './component/controls/modal/modal-body/modal-body.component';
import { ModalFooterComponent } from './component/controls/modal/modal-footer/modal-footer.component';
import { ButtonComponent } from './component/controls/button/button.component';
import { HeaderChangeEnvironmentComponent } from './component/header-change-environment/header-change-environment.component';
import { ContainsByPipe } from './pipe/contains-by.pipe';
import { ListTileComponent } from './component/controls/list-tile/list-tile.component';
import { MessageBannerComponent } from './component/controls/message-banner/message-banner.component';
import { HeaderReconnectComponent } from './component/header-reconnect/header-reconnect.component';
import { ActivitiesDownloadsComponent } from './component/activities-downloads/activities-downloads.component';
import { ActivitiesExecutionComponent } from './component/activities-execution/activities-execution.component';
import { ActivitiesNotificationsComponent } from './component/activities-notifications/activities-notifications.component';
import { ActivitiesOverviewComponent } from './component/activities-overview/activities-overview.component';
import { ActionMenuComponent } from './component/controls/actionmenu/action-menu.component';
import { DatabulkactionComponent } from './component/controls/databulkaction/databulkaction.component';
import { DataheaderbarComponent } from './component/controls/dataheaderbar/dataheaderbar.component';
import { DatatableComponent } from './component/controls/datatable/datatable.component';
import { DataviewComponent } from './component/controls/dataview/dataview.component';
import { DataviewfilterComponent } from './component/controls/dataviewfilter/dataviewfilter.component';
import { PaginationComponent } from './component/controls/pagination/pagination.component';
import { TreeComponent } from './component/controls/tree/tree.component';
import { SettingsAgentsComponent } from './component/settings-agents/settings-agents.component';
import { SettingsAuditComponent } from './component/settings-audit/settings-audit.component';
import { SettingsAuthenticationComponent } from './component/settings-authentication/settings-authentication.component';
import { SettingsExtvendorComponent } from './component/settings-extvendor/settings-extvendor.component';
import { SettingsGeneralComponent } from './component/settings-general/settings-general.component';
import { SettingsManifestComponent } from './component/settings-manifest/settings-manifest.component';
import { SettingsSolutionsComponent } from './component/settings-solutions/settings-solutions.component';
import { SettingsUsersComponent } from './component/settings-users/settings-users.component';
import { FileSizePipe } from './pipe/file-size.pipe';
import { TreeFilterPipe } from './pipe/tree-filter.pipe';
import { NgScrollbarModule, provideScrollbarOptions } from 'ngx-scrollbar';
import { CatalogDownloadComponent } from './component/catalog-download/catalog-download.component';
import { LoginMySupportComponent } from './component/dialogs/login-my-support/login-my-support.component';
import { LoginProxyComponent } from './component/dialogs/login-proxy/login-proxy.component';
import { ConfirmOverwriteComponent } from './component/dialogs/confirm-overwrite/confirm-overwrite.component';
import { DragDropComponent } from './component/dialogs/drag-drop/drag-drop.component';
import { DragDropDirective } from './component/controls/drag-drop-directive/drag-drop.directive';
import { DownloadStartedComponent } from './component/dialogs/download-started/download-started.component';
import { CookieService } from 'ngx-cookie-service';
import { ProductDiscoveryComponent } from './component/dialogs/product-discovery/product-discovery.component';
import { EnableComponentComponent } from './component/dialogs/enable-component/enable-component.component';
import { ModalMessageComponent } from './component/controls/modal-message/modal-message.component';
import { ProductsOverviewComponent } from './component/products-overview/products-overview.component';
import { ProductsDetailsComponent } from './component/products-details/products-details.component';
import { ProductsComponentDetailsComponent } from './component/products-component-details/products-component-details.component';
import { ProductsUpdatesComponent } from './component/products-updates/products-updates.component';
import { LoginCsComponent } from './component/dialogs/login-cs/login-cs.component';
import { InstanceDetailsComponent } from './component/dialogs/instance-details/instance-details.component';
import { PatchSelectionComponent } from './component/dialogs/patch-selection/patch-selection.component';
import { ProductComponentResyncComponent } from './component/product-component-resync/product-component-resync.component';
import { ProductResyncComponent } from './component/dialogs/product-resync/product-resync.component';
import { ProductComponentUaComponent } from './component/product-component-ua/product-component-ua.component';
import { ProductDetailsErrorComponent } from './component/dialogs/product-details-error/product-details-error.component';
import { PreReqCsRegServersComponent } from './component/dialogs/pre-req-cs-reg-servers/pre-req-cs-reg-servers.component';
import { PreReqCsErrorComponent } from './component/dialogs/pre-req-cs-error/pre-req-cs-error.component';
import { WizardComponent } from './component/controls/wizard/wizard.component';
import { ObjectDetailsComponent } from './component/dialogs/object-details/object-details.component';
import { ActivitySystemTaskDetailsComponent } from './component/dialogs/activity-system-task-details/activity-system-task-details.component';
import { ActivitySoftwareRollbackComponent } from './component/dialogs/activity-software-rollback/activity-software-rollback.component';
import { SystemsRegisterComponent } from './component/systems-register/systems-register.component';
import { EnableProductComponent } from './component/dialogs/enable-product/enable-product.component';
import { SystemsEnableComponent } from './component/systems-enable/systems-enable.component';
import { ListDetailsComponent } from './component/dialogs/list-details/list-details.component';
import { HttpInterceptorService } from './service/http-interceptor.service';
import { SettingsProxyComponent } from './component/settings-proxy/settings-proxy.component';
import { SettingsLogComponent } from './component/settings-log/settings-log.component';
import { DataRowFilterPipe } from './pipe/data-row-filter.pipe';
import { TabsComponent } from './component/controls/tabs/tabs.component';
import { SolutionFormComponent } from './component/solution-form/solution-form.component';
import { ImportSolutionFormComponent } from './component/import-solution-form/import-solution-form.component';
import { CanDeactivateService } from './service/can-deactivate.service';
import { SettingsSolutionsSyncComponent } from './component/settings-solutions-sync/settings-solutions-sync.component';
import { SelectComponent, SelectFilterPipe } from './component/controls/select/select.component';
import { NotificationPanelComponent } from './component/dialogs/notification-panel/notification-panel.component';
import { SystemUpdateComponent } from './component/system-update/system-update.component';
import { PlansFormComponent } from './component/plans-form/plans-form.component';
import { PlansDuplicateComponent } from './component/dialogs/plans-duplicate/plans-duplicate.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PlansImportComponent } from './component/plans-import/plans-import.component';
import { PlansExecutionComponent } from './component/plans-execution/plans-execution.component';
import { ExtVenFilesTypeaheadComponent } from './component/controls/ext-ven-files-typeahead/ext-ven-files-typeahead.component';
import { ProdFilesTypeaheadComponent } from './component/controls/prod-files-typeahead/prod-files-typeahead.component';
import { OtscInitDirective } from './directive/otsc-init.directive';
import { DownloadFileMultiComponent } from './component/controls/download-file-multi/download-file-multi.component';
import { ObjectListComponent } from './component/controls/object-list/object-list.component';
import { HighlightTextPipe } from './pipe/highlight-text.pipe';
import { VariableTypeaheadComponent } from './component/controls/variable-typeahead/variable-typeahead.component';
import { ActivityDeploymentStepDetailsComponent } from './component/dialogs/activity-deployment-step-details/activity-deployment-step-details.component';
import { ResizableDividerComponent, ResizableComponent } from './component/controls/resizer/resizer.component';
import { UserComponent } from './component/dialogs/user/user.component';
import { SolutionComponent } from './component/dialogs/solution/solution.component';
import { PageNotFoundComponent } from './component/page-not-found/page-not-found.component';
import { SettingsSupportComponent } from './component/settings-support/settings-support.component';
import { LogPackageComponent } from './component/log-package/log-package.component';
import { CheckboxComponent } from './component/controls/checkbox/checkbox.component';
import { ProductComponentLogsComponent } from './component/product-component-logs/product-component-logs.component';
import { ProductComponentLogsCreateComponent } from './component/product-component-logs-create/product-component-logs-create.component';
import { A11yModule } from '@angular/cdk/a11y';
import { SettingsNotificationComponent } from './component/settings-notification/settings-notification.component';
import { LoginPackageLogsComponent } from './component/dialogs/login-package-logs/login-package-logs.component';
import { DeployUpdateComponent } from './component/dialogs/deploy-update/deploy-update.component';
import { DurationPipe } from './pipe/duration.pipe';
import { ProductSearchHotfixComponent } from './component/product-search-hotfix/product-search-hotfix.component';
import { ProductComponentAdminSettingsComponent } from './component/product-component-admin-settings/product-component-admin-settings.component';
import { SettingsActivityComponent } from './component/settings-activity/settings-activity.component';
import { SystemsManualDiscoverComponent } from './component/systems-manual-discover/systems-manual-discover.component';
import { UnregisterSystemComponent } from './component/dialogs/unregister-system/unregister-system.component';
import { SettingsDatabaseComponent } from './component/settings-database/settings-database.component';
import { SupportcaseComponent } from './component/dialogs/settings-support/supportcase/supportcase.component';
import { SettingsSupportSFTPAuthComponent } from './component/dialogs/settings-support-sftpauth/settings-support-sftpauth.component';
import { SclogsComponent } from './component/dialogs/settings-support/sclogs/sclogs.component';
import { ProductsInstalledComponent } from './component/products-installed/products-installed.component';
import { ZipDownloadProgressComponent } from './component/dialogs/zip-download-progress/zip-download-progress.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    HeaderComponent,
    CatalogComponent,
    ProductsComponent,
    SystemsComponent,
    PlansComponent,
    ActivitiesComponent,
    SettingsComponent,
    FromNowPipe,
    UnregisteredAgentPipe,
    MainComponent,
    BreadcrumbsComponent,
    CatalogFilterPipe,
    CatalogDetailsComponent,
    PlansOverviewComponent,
    PlansDetailsComponent,
    CatalogOverviewComponent,
    OrderByPipe,
    FilterByPipe,
    SystemsOverviewComponent,
    SystemsDetailsComponent,
    AboutBoxComponent,
    UserFormComponent,
    ModalViewComponent,
    ModalViewDirective,
    HeaderProfileComponent,
    ModalTitleComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    ButtonComponent,
    HeaderChangeEnvironmentComponent,
    ContainsByPipe,
    ListTileComponent,
    MessageBannerComponent,
    HeaderReconnectComponent,
    DatatableComponent,
    TreeComponent,
    DataviewComponent,
    TreeFilterPipe,
    FileSizePipe,
    PaginationComponent,
    ActivitiesOverviewComponent,
    ActivitiesExecutionComponent,
    ActivitiesDownloadsComponent,
    ActivitiesNotificationsComponent,
    ActionMenuComponent,
    DataheaderbarComponent,
    DatabulkactionComponent,
    SettingsGeneralComponent,
    SettingsUsersComponent,
    SettingsAuditComponent,
    SettingsAgentsComponent,
    SettingsAuthenticationComponent,
    SettingsSolutionsComponent,
    SettingsExtvendorComponent,
    SettingsManifestComponent,
    DataviewfilterComponent,
    CatalogDownloadComponent,
    LoginMySupportComponent,
    LoginProxyComponent,
    ConfirmOverwriteComponent,
    DragDropComponent,
    DragDropDirective,
    DownloadStartedComponent,
    ProductDiscoveryComponent,
    EnableComponentComponent,
    ModalMessageComponent,
    ProductsOverviewComponent,
    ProductsDetailsComponent,
    ProductsComponentDetailsComponent,
    ProductsUpdatesComponent,
    LoginCsComponent,
    InstanceDetailsComponent,
    PatchSelectionComponent,
    ProductComponentResyncComponent,
    ProductResyncComponent,
    ProductComponentUaComponent,
    ProductDetailsErrorComponent,
    PreReqCsRegServersComponent,
    PreReqCsErrorComponent,
    WizardComponent,
    ObjectDetailsComponent,
    ActivitySystemTaskDetailsComponent,
    ActivitySoftwareRollbackComponent,
    SystemsRegisterComponent,
    EnableProductComponent,
    SystemsEnableComponent,
    ListDetailsComponent,
    SettingsProxyComponent,
    SettingsLogComponent,
    DataRowFilterPipe,
    TabsComponent,
    SolutionFormComponent,
    ImportSolutionFormComponent,
    SettingsSolutionsSyncComponent,
    SelectComponent,
    SelectFilterPipe,
    NotificationPanelComponent,
    SystemUpdateComponent,
    PlansFormComponent,
    PlansDuplicateComponent,
    PlansImportComponent,
    PlansExecutionComponent,
    ExtVenFilesTypeaheadComponent,
    ProdFilesTypeaheadComponent,
    DownloadFileMultiComponent,
    ObjectListComponent,
    HighlightTextPipe,
    VariableTypeaheadComponent,
    ActivityDeploymentStepDetailsComponent,
    ResizableComponent,
    ResizableDividerComponent,
    UserComponent,
    SolutionComponent,
    PageNotFoundComponent,
    SettingsSupportComponent,
    LogPackageComponent,
    CheckboxComponent,
    ProductComponentLogsComponent,
    ProductComponentLogsCreateComponent,
    SettingsNotificationComponent,
    LoginPackageLogsComponent,
    DeployUpdateComponent,
    DurationPipe,
    ProductSearchHotfixComponent,
    ProductComponentAdminSettingsComponent,
    SettingsActivityComponent,
    SystemsManualDiscoverComponent,
    UnregisterSystemComponent,
    SettingsDatabaseComponent,
    SupportcaseComponent,
    SettingsSupportSFTPAuthComponent,
    SclogsComponent,
    ProductsInstalledComponent,
    ZipDownloadProgressComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BaseChartDirective,
    NgScrollbarModule,
    DragDropModule,
    A11yModule,
    OtscInitDirective
  ],
  exports: [
    OtscInitDirective
  ],
  providers: [OrderByPipe, ContainsByPipe, CookieService, UnregisteredAgentPipe, FileSizePipe, CanDeactivateService, DataRowFilterPipe, 
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    provideCharts(withDefaultRegisterables()),
    provideScrollbarOptions({
      visibility: 'hover',
      appearance: 'compact'
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
